@if (stepCount() > 0) {
  <span>Each entry will proceed through a maximum of </span>
  @if (stepCount() === 1) {
    <span class="font-bold">1 step</span> over
  } @else {
    <span class="font-bold">{{ stepCount() }} steps</span> over
  }

  @if (totalDuration() === 1) {
    <span class="font-bold">1 day</span>
  } @else {
    <span class="font-bold">{{ totalDuration() }} days</span>
  }
} @else {
  There are <span class="font-bold">no active steps</span> in this campaign.
}
